import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';

// Get API URL from environment variables or use default
import { API_URL } from '../../utils/apiConfig';

const OrganizationCheck = ({ children }) => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasOrganization, setHasOrganization] = useState(false);
  const [forcePasswordChange, setForcePasswordChange] = useState(false);

  useEffect(() => {
    const checkOrganization = async () => {
      if (!token || !user) {
        setLoading(false);
        return;
      }

      try {
        const commonHeaders = {
          Authorization: `Bearer ${token}`,
          'X-Clinic-Scope': localStorage.getItem('clinicScope') || 'all'
        };
        const [orgResponse, userResponse] = await Promise.all([
          axios.get(`${API_URL}/organizations/my`, { headers: commonHeaders }),
          axios.get(`${API_URL}/auth/me`, { headers: commonHeaders })
        ]);

        if (orgResponse.data.success && orgResponse.data.data) {
          const organization = orgResponse.data.data;
          if (organization.slug === 'detalos-default') {
            setHasOrganization(false);
          } else {
            setHasOrganization(true);
          }
        } else {
          setHasOrganization(false);
        }

        if (userResponse.data.success && userResponse.data.data) {
          const forceChange = userResponse.data.data.forcePasswordChange || false;
          setForcePasswordChange(forceChange);
        }
      } catch (error) {
        console.error('OrganizationCheck error:', error.response?.data ?? error.message);
        setHasOrganization(false);
      } finally {
        setLoading(false);
      }
    };

    checkOrganization();
  }, [token, user]);

  useEffect(() => {
    if (!loading && user) {
      if (forcePasswordChange) {
        navigate('/change-password');
      } else if (!hasOrganization) {
        navigate('/organization-choice');
      }
    }
  }, [loading, hasOrganization, forcePasswordChange, user, navigate]);

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Checking organization setup...
        </Typography>
      </Box>
    );
  }

  if (!hasOrganization) {
    return null; // Will redirect to organization setup
  }

  return children;
};

export default OrganizationCheck; 